import React from 'react';
import styled from 'styled-components';
import COLORS, { ICONS } from '../../../utils/styles';
import { InfoIcon } from '../../common/components/Notification/styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: row;
  height: 5em;
  margin-top: 15em;
`;
const RedBar = styled.section`
  flex: 0 0 auto;
  width: 2em;
  background: ${COLORS.red};
  color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Text = styled.section`
  color: ${COLORS.slateGray};
  background: ${COLORS.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 5em;
`;

const InvalidClient = ({ children }) => (
  <Container>
    <RedBar>
      <InfoIcon icon={ICONS.ALERT} color={COLORS.athensGray} />
    </RedBar>
    <Text>{children}</Text>
  </Container>
);

export default InvalidClient;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/invalid-client.js